module.exports = __webpack_public_path__ + "img/back4.b17d6405.png";